import { navIcons } from '../utils/iconMap';

/**
 * Oyuncu ana navigasyonu — BottomNav + UserDesktopNav ortak kaynak.
 */
export const PLAYER_NAV_ITEMS = [
  { icon: navIcons.home, labelKey: 'nav.home', path: '/dashboard', testId: 'nav-home' },
  { icon: navIcons.code, labelKey: 'nav.code', path: '/activate', testId: 'nav-activate' },
  { icon: navIcons.collection, labelKey: 'nav.collection', path: '/collection', testId: 'nav-collection' },
  { icon: navIcons.leaderboard, labelKey: 'nav.leaderboard', path: '/leaderboard', testId: 'nav-leaderboard' },
  { icon: navIcons.profile, labelKey: 'nav.profile', path: '/profile', testId: 'nav-profile' },
];
